<template>
  <header class="top">
    <div class="header">
      <b class="logo"><img style="max-width:100%;height:auto" src="https://new-official.dev-01.54test.cn/Home/images/zhounian.png" alt="泛亚人力" title="泛亚人力"></b>

      <!-- 移动端面包屑按钮 -->
      <div class="mobile-breadcrumb" @click="toggleMobileMenu">
        <span class="breadcrumb-icon"></span>
      </div>

      <!-- 桌面端导航 -->
      <ul class="desktop-nav" style="width:auto">
        <li>
          <a href="https://new-official.dev-01.54test.cn/" target="_blank" style="font-weight: 700;">首页</a>
        </li>
        <li class="first-level-menu">
          <a style="display: flex; align-items: center;">
            <h2 style="font-size:16px;font-weight:900">企业服务&nbsp;</h2>
            <span class="triangle"></span>
          </a>
          <div class="enterprise-serve-menu" style="">
            <div class="main-board">
              <div class="cate-menu">
                <!-- 第一列：用工管理 -->
                <div class="sub-list">
                  <div class="list">
                    <div class="column-title">
                      <h3>用工管理</h3>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/yuangongpaiqian" target="_blank">
                        员工派遣
                        <p>优化用工结构，提升核心竞争力</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/laowuwaibao" target="_blank">
                        劳务外包
                        <p>降低人力成本，提高管理效能</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/yewuwaibao" target="_blank">
                        业务外包
                        <p>剥离非核心业务或岗位，减少企业运营成本</p>
                      </a>
                    </div>
                  </div>
                </div>

                <!-- 第二列：人事管理 -->
                <div class="sub-list">
                  <div class="list">
                    <div class="column-title">
                      <h3>人事管理</h3>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/qishidaiban" target="_blank">
                        企事代办
                        <p>企业事务专人代跑代办</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/yunpeixun" target="_blank">
                        云培训
                        <p>助力企业人才培养</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/kaowuwaibao" target="_blank">
                        考务外包
                        <p>科学专业地筛选适岗人才</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/laodongfalv" target="_blank">
                        劳动法律
                        <p>企业各类劳动纠纷咨询与协助处理</p>
                      </a>
                    </div>
                  </div>
                </div>

                <!-- 第三列：员工福利 -->
                <div class="sub-list">
                  <div class="list">
                    <div class="column-title">
                      <h3>员工福利</h3>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/yuangongtijian" target="_blank">
                        员工体检
                        <p>体检套餐随心选</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/jiejiarifuli" target="_blank">
                        节假日福利
                        <p>全方位节日福利解决方案</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/jifenfuli" target="_blank">
                        积分福利
                        <p>积分商城线上操作，实现合规双节税</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="big-buttons">
                <div class="blue-button" @click="openOnlineChat">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/在线咨询.png" alt="">
                  <span>在线咨询</span>
                </div>
                <div class="green-button" @click="openOrderExperience">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/预约体验.png" alt="">
                  <span>获取服务方案</span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="first-level-menu">
          <a style="display: flex; align-items: center;" ><h2 style="font-size:16px;font-weight:900">全球用工&nbsp;</h2><span class="triangle"></span></a>
          <div class="enterprise-serve-menu" style="">
            <div class="main-board">
              <div class="cate-menu">
                <!-- 第一列：用工管理 -->
                <div class="sub-list">
                  <div class="list">
                    <div class="column-title">
                      <h3>用工管理</h3>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        名义雇主 EOR
                        <p>跨国用工管理，降低运营成本</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        跨境薪酬 Payroll
                        <p>全球员工的薪酬和福利统一管理</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        全球招聘 Recruitment
                        <p>全球化业务的人才需求方案</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        灵活用工 Contractor
                        <p>打破地域限制，提高用工效率</p>
                      </a>
                    </div>
                  </div>
                </div>

                <!-- 第二列：增值服务 -->
                <div class="sub-list">
                  <div class="list">
                    <div class="column-title">
                      <h3>增值服务</h3>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        工作签证 VISA
                        <p>确保员工合法跨国工作，降低法律风险</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        全球医疗 Medicare
                        <p>便捷、高效的员工健康福利管理服务</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        跨境保障 Insurance
                        <p>全球保险方案推荐</p>
                      </a>
                    </div>
                    <div class="item">
                      <span class="dot"></span>
                      <a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">
                        当地用工咨询 Consultation
                        <p>企业跨国公司注册、财税合规等答疑</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="big-buttons">
                <div class="blue-button"  @click="openOnlineChat">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/在线咨询.png" alt="">
                  <span>在线咨询</span>
                </div>
                <div class="green-button" @click="openOrderExperience">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/预约体验.png" alt="">
                  <span>获取服务方案</span>
                </div>
                <div class="qianlan-button" style="margin-left:60px" @click="openSalaryCalculation">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/预约体验1.png" alt="">
                  <span>国际薪酬测算</span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li><a href="https://new-official.dev-01.54test.cn/StaffService" target="_blank"><h2 style="font-size:16px;font-weight:900">员工服务</h2></a></li>
        <li><a href="https://new-official.dev-01.54test.cn/CustomerSuccess" target="_blank"><h2 style="font-size:16px;font-weight:900">客户案例</h2></a></li>
        <li><a href="https://new-official.dev-01.54test.cn/IndustryStudy" target="_blank"><h2 style="font-size:16px;font-weight:900">政策资讯</h2></a> </li>
        <li class="aboutus-level-menu">
          <a style="display: flex; align-items: center;"> <h2 style="font-size:16px;font-weight:900">关于泛亚&nbsp;</h2><span class="triangle"></span> </a>
          <div class="aboutus-menu">
            <div class="main-board">
              <div class="cate-menu">
                <div class="sub-list">
                  <div class="title">
                    <img src="https://new-official.dev-01.54test.cn/Home/images/icon_lify.png" alt="">
                    <a href="https://new-official.dev-01.54test.cn/AboutUs" target="_blank">了解泛亚</a>
                  </div>
                  <div class="list">
                    <a href="https://new-official.dev-01.54test.cn/AboutUs#gsjj" target="_blank">公司简介</a>
                    <a href="https://new-official.dev-01.54test.cn/AboutUs#jyln" target="_blank">经营理念</a>
                    <a href="https://new-official.dev-01.54test.cn/AboutUs#fzlc" target="_blank">发展历程</a>
                    <a href="https://new-official.dev-01.54test.cn/AboutUs#gsxw" target="_blank">公司新闻</a>
                  </div>
                </div>
                <div class="sub-list">
                  <div class="title">
                    <img src="https://new-official.dev-01.54test.cn/Home/images/icon_whjs.png" alt="">
                    <a href="https://new-official.dev-01.54test.cn/CulturalConstruction" target="_blank">文化建设</a>
                  </div>
                  <div class="list">
                    <a href="https://new-official.dev-01.54test.cn/CulturalConstruction#gyhd" target="_blank">公益活动</a>
                    <a href="https://new-official.dev-01.54test.cn/CulturalConstruction#dqhd" target="_blank">党群活动</a>
                    <a href="https://new-official.dev-01.54test.cn/CulturalConstruction#tjhd" target="_blank">团建活动</a>
                  </div>
                </div>
                <div class="sub-list">
                  <div class="title">
                    <img src="https://new-official.dev-01.54test.cn/Home/images/icon_ryzz.png" alt="">
                    <a href="https://new-official.dev-01.54test.cn/Honor" target="_blank">荣誉资质</a>
                  </div>
                  <div class="list">
                    <a href="https://new-official.dev-01.54test.cn/Honor#qyry" target="_blank">企业荣誉</a>
                    <a href="https://new-official.dev-01.54test.cn/Honor#zzrz" target="_blank">资质认证</a>
                  </div>
                </div>
                <div class="sub-list">
                  <div class="title">
                    <img src="https://new-official.dev-01.54test.cn/Home/images/icon_khcc.png" alt="">
                    <a href="https://new-official.dev-01.54test.cn/CustomerSuccess" target="_blank">客户成功</a>
                  </div>
                  <div class="list">
                    <a href="https://new-official.dev-01.54test.cn/CustomerSuccess#khal" target="_blank">客户案例</a>
                    <a href="https://new-official.dev-01.54test.cn/CustomerSuccess#hzhb" target="_blank">合作伙伴</a>
                  </div>
                </div>
              </div>
              <div class="big-buttons">
                <div class="blue-button" @click="openOnlineChat">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/在线咨询.png" alt="">
                  <span>在线咨询</span>
                </div>
                <div class="green-button" @click="openOrderExperience">
                  <img src="https://new-official.dev-01.54test.cn/Home/images/预约体验.png" alt="">
                  <span>了解详情</span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <div class="login" id="login">
          <span @click="goToLogin">
            <a id="enterpriseLink" href="javascript:void(0)">企业登录</a>
          </span>
        </div>
      </ul>

      <!-- 移动端导航菜单 -->
      <div id="mobile-menu" class="mobile-nav" v-show="mobileMenuOpen">
        <div class="mobile-nav-content">
          <ul>
            <li><a href="https://new-official.dev-01.54test.cn/" target="_blank">首页</a></li>
            <li>
              <a href="javascript:void(0)" class="mobile-submenu-toggle" @click="toggleMobileSubmenu('enterprise')">企业服务</a>
              <ul class="mobile-submenu" v-show="mobileSubmenu.enterprise">
                <li><a href="https://new-official.dev-01.54test.cn/yuangongpaiqian" target="_blank">员工派遣</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/laowuwaibao" target="_blank">劳务外包</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/yewuwaibao" target="_blank">业务外包</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/qishidaiban" target="_blank">企事代办</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/yunpeixun" target="_blank">云培训</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/kaowuwaibao" target="_blank">考务外包</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/laodongfalv" target="_blank">劳动法律</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/yuangongtijian" target="_blank">员工体检</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/jiejiarifuli" target="_blank">节假日福利</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/jifenfuli" target="_blank">积分福利</a></li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" class="mobile-submenu-toggle" @click="toggleMobileSubmenu('global')">全球用工</a>
              <ul class="mobile-submenu" v-show="mobileSubmenu.global">
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">名义雇主 EOR</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">跨境薪酬 Payroll</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">全球招聘 Recruitment</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">灵活用工 Contractor</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">工作签证 VISA</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">全球医疗 Medicare</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">跨境保障 Insurance</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/globalEOR" target="_blank">当地用工咨询 Consultation</a></li>
              </ul>
            </li>
            <li><a href="https://new-official.dev-01.54test.cn/StaffService" target="_blank">员工服务</a></li>
            <li><a href="https://new-official.dev-01.54test.cn/CustomerSuccess" target="_blank">客户案例</a></li>
            <li><a href="https://new-official.dev-01.54test.cn/IndustryStudy" target="_blank">政策资讯</a></li>
            <li>
              <a href="javascript:void(0)" class="mobile-submenu-toggle" @click="toggleMobileSubmenu('about')">关于泛亚</a>
              <ul class="mobile-submenu" v-show="mobileSubmenu.about">
                <li><a href="https://new-official.dev-01.54test.cn/AboutUs" target="_blank">了解泛亚</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/AboutUs#gsjj" target="_blank">公司简介</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/AboutUs#jyln" target="_blank">经营理念</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/AboutUs#fzlc" target="_blank">发展历程</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/AboutUs#gsxw" target="_blank">公司新闻</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/CulturalConstruction" target="_blank">文化建设</a></li>
                <li><a href="https://new-official.dev-01.54test.cn/Honor" target="_blank">荣誉资质</a></li>
              </ul>
            </li>
          </ul>
          <div class="mobile-nav-buttons">
            <div class="blue-button" @click="openOnlineChat">
              <img src="https://new-official.dev-01.54test.cn/Home/images/在线咨询.png" alt="">
              <span>在线咨询</span>
            </div>
            <div class="green-button" @click="openOrderExperience">
              <img src="https://new-official.dev-01.54test.cn/Home/images/预约体验.png" alt="">
              <span>获取服务方案</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TopNav',
  data() {
    return {
      mobileMenuOpen: false,
      mobileSubmenu: {
        enterprise: false,
        global: false,
        about: false
      }
    }
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    toggleMobileSubmenu(type) {
      this.mobileSubmenu[type] = !this.mobileSubmenu[type]
    },
    openOnlineChat() {
      if (window.ECHAT) {
        window.ECHAT.customMiniChat()
      } else {
        alert('在线客服功能正在维护中，请稍后再试')
      }
    },
    openOrderExperience() {
      window.open('https://new-official.dev-01.54test.cn/OrderExperience', '_blank')
    },
    openSalaryCalculation() {
      window.open('https://new-official.dev-01.54test.cn/salarycalculation', '_blank')
    },
    goToLogin() {
      this.$router.push('/Login')
    }
  }
}
</script>

<style scoped>
/* ========== 父项目 reset.css 基础样式 ========== */
.top {
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  background: #fff;
  height: 80px;
  position: fixed;
}

.header {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100vw !important;
  max-width: 100vw !important;
  min-width: 100vw !important;
  margin: 0 !important;
  padding: 0 !important;
  z-index: 1000 !important;
  background: #fff !important;
  box-sizing: border-box !important;
  height: 80px !important;
  flex-wrap: nowrap !important;
}

@media screen and (min-width: 1025px) {
  .header {
    width: 100% !important;
    max-width: 1200px !important;
    min-width: auto !important;
    margin: 0 auto !important;
  }
}

/* 初始隐藏导航 */
.header li a.menul {
  border: none;
}

/* JS执行完成后显示 */
.header-visible .header li a.menul {
  border-bottom: 2px solid #ff424f;
}

.logo {
  float: left;
  margin-top: 10px;
  flex-shrink: 0;
  width: 180px;
  height: auto;
}

@media screen and (max-width: 1199px) {
  .logo {
    width: 120px !important;
    height: auto !important;
  }
}

/* ========== 桌面端导航 ========== */
.desktop-nav {
  position: relative;
  float: left;
  margin: 0 120px 0 40px;
  vertical-align: middle;
  padding: 0;
  list-style: none;
}

.desktop-nav > li {
  float: left;
  font-size: 16px;
  margin: 0 20px;
  font-weight: 500 !important;
  position: relative;
}

.desktop-nav > li > a {
  text-decoration: none;
  display: block;
  color: #424a5e;
  line-height: 78px;
  border-bottom: 2px solid #fff;
  padding: 0;
  font-size: 16px;
}

.desktop-nav > li > a > h2 {
  display: block;
  color: #424a5e;
  line-height: 78px;
  font-family: Microsoft YaHei !important;
  margin: 0;
}

.desktop-nav > li > a:hover {
  color: #ff424f;
  cursor: pointer;
  border-bottom: 2px solid #ff424f;
}

.desktop-nav > li > a.menul {
  color: #ff424f;
  cursor: pointer;
  border-bottom: 2px solid #ff424f;
}

.triangle {
  display: inline-block;
  border-left: 3px solid #fff;
  border-top: 6px solid #ff424f;
  border-right: 3px solid #fff;
  border-bottom: 2px solid #fff;
}

/* ========== 企业登录按钮 ========== */
.login {
  margin-left: 35px;
  display: inline-block;
  padding: 25px 0;
}

.login span {
  display: inline-block;
  height: 30px;
  width: 80px;
  text-align: center;
  line-height: 30px;
  vertical-align: middle;
  /* padding: 0 10px; */
  cursor: pointer;
  border-radius: 0.2em;
  font-size: 14px;
  border: 1px solid #409EFF;
  color: #409EFF;
  margin-left: 10px;
}

.login span:hover {
  /* background: #3674ef; */
  /* color: #fff; */
   background-color:  #409EFF;
  border: 1px solid #409EFF;
  color: #fff;
 
}

.login span a {
  color: #409EFF;
  text-decoration: none;
   font-size: 14px;
}

.login span:hover a {
  color: #fff;
}

/* ========== 企业服务/全球用工 下拉菜单 ========== */
.enterprise-serve-menu {
  display: none;
}

.first-level-menu:hover .enterprise-serve-menu {
  position: absolute;
  left: -330px;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 3px 16px rgba(18, 76, 133, 0.14);
  background: #fff;
  z-index: 99998;
}

.first-level-menu:hover > a {
  color: #ff424f;
  cursor: pointer;
  border-bottom: 2px solid #ff424f;
}

.enterprise-serve-menu * {
  box-sizing: border-box;
}

.enterprise-serve-menu .main-board {
  flex: 1;
  width: auto !important;
}

.enterprise-serve-menu .cate-menu {
  display: flex;
  flex-direction: row;
  padding: 32px 65px 40px;
}

.enterprise-serve-menu .sub-list {
  display: flex;
  flex-direction: column;
  margin: 0 41px;
}

.column-title {
  margin-bottom: 15px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaeaea;
}

.column-title h3 {
  font-size: 18px;
  color: #333333;
  line-height: 16px;
  font-weight: 700;
  font-family: Microsoft YaHei;
  font-weight: bold;
  margin: 0;
  padding: 0;
}

.enterprise-serve-menu .sub-list .list {
  width: 250px;
}

.enterprise-serve-menu .sub-list .list .item {
  position: relative;
  min-width: 190px;
  height: 63px;
  padding-left: 16px;
}

.enterprise-serve-menu .sub-list .list .item:hover a {
  color: #FF4150;
}

.enterprise-serve-menu .sub-list .list .item:hover a p {
  color: #FF4150;
}

.enterprise-serve-menu .sub-list .list .item::before {
  position: absolute;
  left: 18px;
  top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
 
  content: '';
}

.enterprise-serve-menu .sub-list .list a {
  position: relative;
  min-width: 124px;
  height: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 14px;
  line-height: 30px;
  text-align: left;
  color: #333333;
  background: transparent;
  border: none;
  font-weight: 400;
  text-decoration: none;
  display: block;
}

.enterprise-serve-menu .sub-list .list .item p {
  font-size: 12px;
  line-height: 16px;
  color: #a6a6a6;
  font-weight: 400;
  margin: 0;
}

.enterprise-serve-menu .sub-list .list .item .dot {
  position: absolute;
  left: 0px;
  top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: red;
}

/* ========== 下拉菜单底部按钮 ========== */
.enterprise-serve-menu .big-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 52px;
  user-select: none;
}

.enterprise-serve-menu .big-buttons div,
.enterprise-serve-menu .big-buttons a {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 54px;
  border-radius: 4px;
  cursor: pointer;
  transition: all ease .3s;
}

.enterprise-serve-menu .big-buttons div:hover {
  opacity: 0.8;
  transition: all ease .3s;
}

.enterprise-serve-menu .big-buttons .green-button {
  background: linear-gradient(180deg, #37B78C 0%, #0CA361 100%);
}

.enterprise-serve-menu .big-buttons .blue-button {
  margin-right: 70px;
  background: linear-gradient(180deg, #4987EC 0%, #4E6EDD 100%);
}

.enterprise-serve-menu .big-buttons .qianlan-button {
  margin-left: 60px;
  background: linear-gradient(180deg, #0CC6E4 0%, #0399C8 100%);
}

.enterprise-serve-menu .big-buttons img {
  display: block;
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.enterprise-serve-menu .big-buttons span {
  font-size: 18px;
  font-weight: 400;
  background: transparent;
  color: #FFFFFF;
}

/* ========== 关于泛亚 下拉菜单 ========== */
.aboutus-menu {
  display: none;
}

.aboutus-level-menu:hover .aboutus-menu {
  position: absolute;
  left: -174px;
  height: 369px;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 3px 16px rgba(18, 76, 133, 0.14);
  background: #fff;
  z-index: 99998;
}

.aboutus-level-menu:hover > a {
  color: #ff424f;
  cursor: pointer;
  border-bottom: 2px solid #ff424f;
}

.aboutus-menu * {
  box-sizing: border-box;
}

.aboutus-menu .main-board {
  flex: 1;
  width: auto !important;
}

.aboutus-menu .cate-menu {
  display: flex;
  flex-direction: row;
  padding: 20px 8px;
}

.aboutus-menu .sub-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 12px;
}

.aboutus-menu .sub-list .title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 45px;
  border-bottom: 1px solid #D1DBE2;
}

.aboutus-menu .sub-list .title img {
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.aboutus-menu .sub-list .title a {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
  border: none;
  text-decoration: none;
}

.aboutus-menu .sub-list .list {
  padding-top: 10px;
}

.aboutus-menu .sub-list .list a {
  min-width: 124px;
  height: 30px;
  padding: 0 10px;
  margin-bottom: 10px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  background: transparent;
  border: none;
  transition: all ease .3s;
  text-decoration: none;
  display: block;
}

.aboutus-menu .sub-list .list a:hover {
  box-shadow: 0px 3px 10px #D1E9FF;
  color: #1D67AF;
  background: #fff;
  border: none;
  transition: all ease .3s;
}

.aboutus-menu .big-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 74px;
  padding-bottom: 20px;
  user-select: none;
}

.aboutus-menu .big-buttons div,
.aboutus-menu .big-buttons a {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 54px;
  border-radius: 4px;
  cursor: pointer;
  transition: all ease .3s;
}

.aboutus-menu .big-buttons div:hover {
  opacity: 0.8;
}

.aboutus-menu .big-buttons .green-button {
  background: linear-gradient(180deg, #37B78C 0%, #0CA361 100%);
}

.aboutus-menu .big-buttons .blue-button {
  margin-right: 70px;
  background: linear-gradient(180deg, #4987EC 0%, #4E6EDD 100%);
}

.aboutus-menu .big-buttons img {
  display: block;
  width: 25px;
  height: 25px;
  margin-right: 10px;
}

.aboutus-menu .big-buttons span {
  font-size: 18px;
  font-weight: 400;
  background: transparent;
  color: #FFFFFF;
}

/* ========== 移动端样式 ========== */
.mobile-breadcrumb {
  display: none;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.breadcrumb-icon {
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  position: relative;
  top: 14px;
  left: 3px;
}

.breadcrumb-icon:before,
.breadcrumb-icon:after {
  content: '';
  display: block;
  width: 24px;
  height: 2px;
  background: #333;
  position: absolute;
  transition: all 0.3s ease;
}

.breadcrumb-icon:before {
  top: -8px;
}

.breadcrumb-icon:after {
  top: 8px;
}

.mobile-nav {
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  height: calc(100% - 80px);
  background: #fff;
  z-index: 99998;
  overflow-y: auto;
}

.mobile-nav-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 20px;
}

.mobile-nav-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.mobile-nav-content ul li {
  margin-bottom: 1px;
  width: 100%;
}

.mobile-nav-content ul li a {
  display: block;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  background: #fff;
  border-radius: 0;
  font-size: 16px;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
  white-space: normal;
}

.mobile-nav-content ul li a:hover {
  background: #f5f5f5;
}

.mobile-submenu {
  display: none;
  margin-top: 5px;
  margin-left: 20px;
  list-style: none;
  padding: 0;
}

.mobile-submenu li a {
  font-size: 14px;
  padding: 10px 15px;
}

.mobile-nav-buttons {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-nav-buttons .blue-button,
.mobile-nav-buttons .green-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 4px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.mobile-nav-buttons .blue-button {
  background: linear-gradient(180deg, #4987EC 0%, #4E6EDD 100%);
}

.mobile-nav-buttons .green-button {
  background: linear-gradient(180deg, #37B78C 0%, #0CA361 100%);
}

.mobile-nav-buttons img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* ========== 响应式布局 ========== */
@media screen and (max-width: 1199px) {
  .desktop-nav {
    display: none !important;
  }

  .mobile-breadcrumb {
    display: block;
  }

  .mobile-nav {
    display: block;
  }

  .header {
    width: 100% !important;
    margin: 0 auto !important;
    padding: 10px 20px !important;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box !important;
    position: relative !important;
    z-index: 1000 !important;
  }

  .logo {
    width: 120px !important;
    height: auto !important;
    order: 1;
  }

  .header > .mobile-breadcrumb {
    order: 2;
  }
}
</style>
